<template>
  <div class="portlet">
    <div class="portlet-head">
      <h3><i class="fas fa-id-card"></i> Moje konto</h3>
    </div>
    <div class="portlet-body form-horizontal">
      <div class="form-group row">
        <label class="col-lg-3 col-form-label">Firma:</label>
        <div class="col-lg-6 align-self-center decoration">{{getMainCompanyName}}</div>
      </div>
      <div class="form-group row">
        <label class="col-lg-3 col-form-label">Stanowisko:</label>
        <div class="col-lg-6 align-self-center decoration">{{$store.state.user.data.role}}</div>
      </div>
      <div class="form-group row">
        <label class="col-lg-3 col-form-label">Adres E-mail:</label>
        <div
          class="col-lg-6 d-flex justify-content-between align-items-center decoration"
        >{{$store.state.user.data.email}}</div>
      </div>
      <div class="form-group row">
        <label class="col-lg-3 col-form-label">Hasło:</label>
        <div class="col-lg-6 d-flex justify-content-between align-items-center decoration">
          ********
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="changePassword()"
          >Zmień hasło</button>
        </div>
      </div>
      <hr />
      <div class="section-title">Profil:</div>
      <ValidationObserver
        ref="formValidation"
        tag="form"
        @submit.prevent="onSubmit"
        class="form-horizontal"
      >
        <div class="form-group row">
          <label for="firstName" class="col-lg-3 col-form-label">Imię:</label>
          <div class="col-lg-6">
            <ValidationProvider name="firstname" rules="required" v-slot="validationContext">
              <b-form-input
                id="firstName"
                v-model="form.firstname"
                type="text"
                :state="getValidationState(validationContext)"
              ></b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row">
          <label for="lastName" class="col-lg-3 col-form-label">Nazwisko:</label>
          <div class="col-lg-6">
            <ValidationProvider name="lastname" rules="required" v-slot="validationContext">
              <b-form-input
                id="lastName"
                v-model="form.lastname"
                type="text"
                :state="getValidationState(validationContext)"
              ></b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row">
          <label for="phone" class="col-lg-3 col-form-label">Telefon:</label>
          <div class="col-lg-6">
            <ValidationProvider name="phone" rules="required" v-slot="validationContext">
              <b-form-input
                id="phone"
                v-model="form.phone"
                type="text"
                :state="getValidationState(validationContext)"
              ></b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-lg-9 text-right">
            <button class="btn btn-primary btn-wide">Zapisz</button>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <ModalChangePassword />
  </div>
</template>

<script>
import ModalChangePassword from "../components/account/ModalChangePassword";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TheAccount",
  components: { ModalChangePassword },
  data() {
    return {
      form: {}
    };
  },
  computed: {
    ...mapGetters("user", ["getInfo"]),
    ...mapGetters("company", ["getMainCompanyName"])
  },
  created: function() {
    let user = this.getInfo;
    this.form.firstname = user.firstname;
    this.form.lastname = user.lastname;
    this.form.phone = user.phone;
  },
  methods: {
    ...mapActions("user", ["update"]),
    getValidationState({ dirty, validated, valid = null }) {
      return dirty && validated ? valid : null;
    },
    onSubmit() {
      this.$refs.formValidation.validate().then(success => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        this.update(this.form)
          .then(() => {
                  this.$refs.formValidation.reset();
          })
          .catch(error => {
            this.$refs.formValidation.setErrors(error.response.data.fields);
          });
      });
    },
    changePassword() {
      this.$bvModal.show("changepassword-modal");
    }
  }
};
</script>
